<template>
    <div class="player-wrapper">
        <div ref="playerContainer" style="width: 100%; height: 100%;" class="bm-player"></div>
        <div class="PlayListView" v-if="showPlaylist">
            <PlayList @actFromChannelList="actFromChannelList" @closePlayList="actShowPlaylist" :liveplayerpayload="liveplayerpayload"
                :episodesList="episodesList" :seasonsData="seasonsData"
                v-if="liveplayerpayload && (liveplayerpayload.category == 'TVSHOW' && liveplayerpayload.objecttype == 'CONTENT')" />
            <ChannelList @actFromChannelList="actFromChannelList" @closePlayList="actShowPlaylist" :liveplayerpayload="liveplayerpayload"
                v-if="liveplayerpayload && liveplayerpayload.category == 'TVCHANEL'" />
            <RelatedContentList @actFromChannelList="actFromChannelList" @closePlayList="actShowPlaylist" :liveplayerpayload="liveplayerpayload"
                :relatedContentList="relatedList" v-if="liveplayerpayload && liveplayerpayload.category == 'MOVIE'" />
        </div>
        <div class="error-message blurred" v-if="errorMessage">
            <div class="error-message-content">
                <div class="error-message-header">
                <div class="error-message-title" v-if="errorMessage && errorMessage !== 'liveContentAccessError'">
                    {{ 'Error' }}
                </div>
                <!-- <div class="error-message-icon">
                    <img src="@/assets/live-channel/error.png" />
                    </div> -->
                </div>
                <hr v-if="errorMessage !== 'liveContentAccessError'"/>
                <div class="error-message-body">
                <div class="error-message-text">
                    <template v-if="errorMessage == 'liveContentAccessError'">
                        <p>{{ getUnsubscribedMessage(liveplayerpayload) }}</p>
                    </template>
                    <template v-else>
                        <p>{{ $t(errorMessage ? errorMessage : 'Unknown error') }}</p>
                        <p v-if="errorDesscription">{{ $t(errorDesscription) }}</p>
                    </template>
                </div>
                </div>
                <div class="error-message-footer">
                    <div class="error-message-btns btn_one" @click="actNextChannelChange"
                        v-if="(liveplayerpayload && !(liveplayerpayload.category == 'MOVIE' || liveplayerpayload.objecttype == 'CONTENT'))">
                        {{ 'Next Channel' }}
                    </div>
                <div class="error-message-btns btn_two" @click="actClosePlayer()">
                    <span> {{ $t('Close Player') }} </span>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapGetters, mapActions } from "vuex";
    import moment from "moment-timezone";
    import { playbackIdentity, finiteSeconds, PlaybackWatchSession } from "@/utils/playbackAnalytics";
    import PlaybackUtilities from "@/mixins/playbackUtilities.js";
    import { _providerId } from "@/provider-config.js";
    import { eventBus } from "@/eventBus";
    import { store } from "@/store/store";
    import FirebaseActions from "@/mixins/FirebaseActions";
    import googleAnalytics from "@/mixins/googleAnalytics.js";
    import Utility from "@/mixins/Utility.js";
    import Redirection from "@/mixins/redirection.js";
    import MMAnalytics from "@/mixins/mmAnalytics.js";

    export default {
        props: ["liveplayerpayloadSingle", "programPayload"],
        data() {
            return {
                descStyle: {
                    font: 1,
                    width: 100
                },
                playerConfig: {
                    key: '9e37bc6c-3ef8-4690-a2e0-a70c35cb1420',
                    playback: {
                        muted: false,
                        autoplay: true,
                        // seekToLiveThreshold: 180,      // <–– 2–3 min as required
                    },
                    // live: {
                    //     lowLatency: {
                    //     targetLatency: 20,              // <–– 2–3 min as required
                    //     catchup: {
                    //         playbackRateThreshold: 0.075,
                    //         seekThreshold: 5,
                    //         playbackRate: 1.2,
                    //     },
                    //     fallback: {
                    //         playbackRateThreshold: 0.075,
                    //         seekThreshold: 5,
                    //         playbackRate: 0.95,
                    //     },
                    //     },
                    // },
                    // tweaks: {
                    //     RESTART_THRESHOLD: 0.2,
                    //     RESTART_THRESHOLD_DELTA: 0.05,
                    //     STARTUP_THRESHOLD: 0.2,
                    //     STARTUP_THRESHOLD_DELTA: 0.05,
                    //     LOW_LATENCY_BUFFER_GUARD: 0.8,
                    // },
                    buffer: {
                        video: {
                            bufferAheadToKeep: 10, // <–– 2–3 min as required
                            backwardduration: 10,
                            forwardduration:   10    // <–– 1 min as required
                        },
                    },
                    location: {
                        // Use the UI JS and CSS files either manually or through tools like https://www.jsdelivr.com
                        // ui: 'https://cdn.jsdelivr.net/npm/bitmovin-player-ui@4/dist/js/bitmovinplayer-ui.js',
                        // ui_css: 'https://cdn.jsdelivr.net/npm/bitmovin-player-ui@4/dist/css/bitmovinplayer-ui.css',
                    },
                    style: { branding: false },
                    ui: false,
                },
                liveplayerpayload: null,
                analyticsSession: null,
                nextPrevChannelHideShow: false,
                showPlaylist: false,
                channelListActive: false,
                nextChannelDisplay: {},
                currentChannelDisplay: null,
                prevChannelDisplay: {},
                placeHolder: {
                    portrait: require("@/assets/placeholder-port.svg"),
                    landScape: require("@/assets/placeholder-lands.svg"),
                    square: require('@/assets/placeholder-square.svg')
                },
                seasonsData: null,
                localDisplayLang: null,
                episodesList: null,
                episodePageNum: 1,
                relatedList: null,
                currentIndex: 0,
                showNextPopup: false,
                countdown: 10,
                nextBtnprogress: 0,
                countdownTimer: null,
                activeSelectedDate: null,
                programsData: [],
                viewSessionId: null,
                errorMessage: "",
                errorDesscription: "",
                nextItem: null, 
                intervalId: null,
                remainingTime: 5 * 60 * 1000 // 5 minutes
            }
        },
        components: {
            ChannelList: () => import(/* webpackChunkName: "channelList" */ "@/components/LivePlayer/ChannelList.vue"),
            PlayList: () => import(/* webpackChunkName: "playList" */ "@/components/LivePlayer/PlayList.vue"),
            RelatedContentList: () => import(/* webpackChunkName: "relatedContentList" */ "@/components/LivePlayer/RelatedContentList.vue"),
            Description: () => import(/* webpackChunkName: "description" */ "@/components/Text/Description.vue"),
        },
        computed: {
            ...mapGetters(["appConfig", "subscriberid", "profileid", "getContentPlayingFromRails", "getCountry", "getAllLanguageFullForm",]),
        },
        watch: {
            nextChannelDisplay: {
                handler(newVal) {
                this.$nextTick(() => {
                    const nextBtn = document.querySelector(
                    '.bmpui-ui-next-channel-button'
                    );

                    if (!nextBtn) return;

                    const isVisible = !!(newVal && newVal.title);

                    nextBtn.style.display = isVisible ? 'flex' : 'none';
                    nextBtn.style.visibility = isVisible ? 'visible' : 'hidden';
                    nextBtn.style.pointerEvents = isVisible ? 'auto' : 'none';
                });
                },
                deep: true,
                immediate: true,
            },

            prevChannelDisplay: {
                handler(newVal) {
                this.$nextTick(() => {
                    const prevBtn = document.querySelector(
                    '.bmpui-ui-prev-channel-button'
                    );

                    if (!prevBtn) return;

                    const isVisible = !!(newVal && newVal.title);

                    prevBtn.style.display = isVisible ? 'flex' : 'none';
                    prevBtn.style.visibility = isVisible ? 'visible' : 'hidden';
                    prevBtn.style.pointerEvents = isVisible ? 'auto' : 'none';
                });
                },
                deep: true,
                immediate: true,
            },

            showNextPopup: {
                handler(newVal) {
                
                this.$nextTick(() => {
                    this.updateNextContentPopup();
                });
                },
                deep: true,
                immediate: true,
            },

            countdown: {
                handler() {
                    this.updateNextContentPopup();
                },
                deep: true,
                immediate: true
            },

            nextBtnprogress: {
                handler() {
                    this.updateNextContentPopup();
                },
                deep: true,
                immediate: true
            }
        },
        created() {
            this.liveplayerpayload = { ...this.liveplayerpayloadSingle };
            // const today = moment().tz(moment.tz.guess()); // guess local timezone
            // const localDate = today.format("YYYY-MM-DD");
            // this.activeSelectedDate = localDate;
            // Register modules
        },
        mounted() {
            window.addEventListener("pagehide", this.flushPlaybackAnalytics);
            this.liveplayerpayload = { ...this.liveplayerpayloadSingle };
            if(this.liveplayerpayload.category == "TVCHANEL" && this.liveplayerpayload.objecttype !== "EPGPROGRAMME") {
                this.currentChannelDisplay = this.liveplayerpayload;
            }
            document.body.style.overflow = "hide"
            this.viewSessionId = this.getSessionUUID();
            this.localDisplayLang = localStorage.getItem("setDisplayLanguageCode") || 'en';
            window.currentPageIndex = 1;
            window.bmPlayer = new bitmovin.player.Player(this.$refs.playerContainer, this.playerConfig);
            if (this.localDisplayLang == 'es') {
                var localizationConfig = {
                    language: 'es',
                    vocabularies: {
                        es: this.Vocabulary(),
                    }
                };
                bitmovin.playerui.i18n.setConfig(localizationConfig);
            } else {
              var localizationConfig = {
                    language: 'en'
                };  
                bitmovin.playerui.i18n.setConfig(localizationConfig);
            }
            window.playerEvent = bitmovin.player.PlayerEvent;
            this.$nextTick(() => {
                // Create new instance
                const mmBitmovinPlugin = new MMBitmovinSDKIntgr();
                window.mmBitmovinPlugin = mmBitmovinPlugin;
                this.setupPlayer(this.liveplayerpayload).then((success) => {
                    console.log('setupPlayer_success', success);
                    if (this.liveplayerpayload.category == 'MOVIE') {
                        this.relatedList = [];
                        this.relatedList.push(this.liveplayerpayload);
                        this.fetchRelatedContents();
                    } else if (this.liveplayerpayload.objecttype == "CONTENT") {
                        this.getSeasonList();
                    } else {
                        if (this.getContentPlayingFromRails && this.liveplayerpayload.objecttype === "CHANEL") {
                            this.contentListFromRail();
                        } else {
                            this.activeGenreContentList();
                        }
                    }
                }).catch((error) => {
                    window.uiManager = new bitmovin.playerui.UIManager(window.bmPlayer, this.createUIContainer(contentInformation));
                    this.$nextTick(() => {
                        this.prevChannelDisplay = { ...this.prevChannelDisplay };
                        this.nextChannelDisplay = { ...this.nextChannelDisplay };
                    });
                    console.log('setupPlayer_error', error);
                });
                window.bmPlayer.on(bitmovin.player.PlayerEvent.Ready, () => {this.onPlayerReadyHandler(this.liveplayerpayload)});
                window.bmPlayer.on(bitmovin.player.PlayerEvent.SourceLoaded,() => {this.onSourceLoadedHandler(this.liveplayerpayload)});
                window.bmPlayer.on(bitmovin.player.PlayerEvent.Error, (err) => {
                    this.analyticsSession?.pause();
                    console.error('Player error:', err);
                    console.error('Player error:code', err.code);
                    if(err.code == 1402 || err.code == 1400 || err.code == 1208 || (err.data && err.data.statusCode == 403)) {
                        console.log('Player error:_', err);
                        if (err.code == 1208 || (err.data && err.data.statusCode == 403)) {
                            this.errorMessage = 'liveContentAccessError';
                            this.errorDesscription = '';
                        } else {
                            this.errorMessage = err.name;
                            this.errorDesscription = err.message;
                        }
                    }
                    if (uiManager && uiManager.getUI()) {
                        console.error('Player error:__', err);
                        uiManager.getUI().show(); // 👈 ensures UI visible
                    }
                });
                window.bmPlayer.on(bitmovin.player.PlayerEvent.Play, () => { 
                    this.setStreamApiCall(this.liveplayerpayload);
                    this.startTimer();
                });
                window.bmPlayer.on(bitmovin.player.PlayerEvent.Playing, () => { 
                    this.analyticsSession?.play();
                });
                window.bmPlayer.on(bitmovin.player.PlayerEvent.Paused, () => { 
                    this.analyticsSession?.pause();
                    this.unsetStreamApiCall(this.liveplayerpayload);
                    this.pauseTimer();
                });
                window.bmPlayer.on(bitmovin.player.PlayerEvent.SourceUnloaded, () => { 
                    this.analyticsSession?.pause();
                });
                window.bmPlayer.on(bitmovin.player.PlayerEvent.Destroy, () => { })
                window.bmPlayer.on(bitmovin.player.PlayerEvent.PlaybackFinished, () => {
                    this.updateDataOnFirebase({ ...this.liveplayerpayload });
                    // if popup was never shown/started, figure out the next item now
                    if (!this.nextItem) {
                        const list = this.getNextItemList();
                        const nextIdx = this.currentIndex + 1;
                        if (list && nextIdx < list.length) {
                            this.nextItem = list[nextIdx];
                        }
                    }
                    if (this.nextItem) {
                        this.playNextNow();
                    }
                });
                window.bmPlayer.on(bitmovin.player.PlayerEvent.Warning, () => { })
                window.bmPlayer.on(bitmovin.player.PlayerEvent.StallStarted, () => { this.analyticsSession?.pause(); })
                window.bmPlayer.on(bitmovin.player.PlayerEvent.StallEnded, () => { if (window.bmPlayer.isPlaying()) this.analyticsSession?.play(); })
                window.bmPlayer.on(bitmovin.player.PlayerEvent.Muted, () => { })
                window.bmPlayer.on(bitmovin.player.PlayerEvent.Unmuted, () => { })
                window.bmPlayer.on(bitmovin.player.PlayerEvent.TimeChanged, () => { this.onTimeChanged(); })
                window.bmPlayer.on(bitmovin.player.PlayerEvent.Seek, () => { this.analyticsSession?.pause(); })
                window.bmPlayer.on(bitmovin.player.PlayerEvent.Seeked, () => { if (window.bmPlayer.isPlaying()) this.analyticsSession?.play(); })
                window.bmPlayer.on(bitmovin.player.PlayerEvent.PlaybackSpeedChanged, () => { }) 

                // Quality and adaptation events

                window.bmPlayer.on(bitmovin.player.PlayerEvent.VideoPlaybackQualityChanged, () => { })
                window.bmPlayer.on(bitmovin.player.PlayerEvent.AudioPlaybackQualityChanged, () => { })
                window.bmPlayer.on(bitmovin.player.PlayerEvent.AudioChanged, () => { })
                window.bmPlayer.on(bitmovin.player.PlayerEvent.VideoAdaptation, () => { })
                window.bmPlayer.on(bitmovin.player.PlayerEvent.AudioAdaptation, () => { }) 

                // Subtitles and captions events
                window.bmPlayer.on(bitmovin.player.PlayerEvent.SubtitleAdded, function() {
                    var firstSubtitle = player.subtitles.list()[0];
                    player.subtitles.enable(firstSubtitle.id);
                });
                window.bmPlayer.on(bitmovin.player.PlayerEvent.SubtitleChanged, () => { })
                window.bmPlayer.on(bitmovin.player.PlayerEvent.SubtitleRemoved, () => { })
                window.bmPlayer.on(bitmovin.player.PlayerEvent.CueEnter, () => { })
                window.bmPlayer.on(bitmovin.player.PlayerEvent.CueExit, () => { }) 

                // UI and metadata events

                window.bmPlayer.on(bitmovin.player.PlayerEvent.FullscreenEnter, () => { })
                window.bmPlayer.on(bitmovin.player.PlayerEvent.FullscreenExit, () => { })
                window.bmPlayer.on(bitmovin.player.PlayerEvent.PlayerActive, () => { })
                window.bmPlayer.on(bitmovin.player.PlayerEvent.PlayerInactive, () => { })
                window.bmPlayer.on(bitmovin.player.PlayerEvent.Metadata, () => { });
                window.bmPlayer.on(bitmovin.player.PlayerEvent.ViewModeChanged, () => { 
                    console.log("ViewModeChanged")
                });
            });
        },
        methods: {
            ...mapActions([
                "mapEpgXmlData",
                "listContent",
                "listGenerContent",
                "getContent",
                "authorizeCurrentStreamApi",
                "setCurrentStreamApi",
                "unsetCurrentStreamApi"
            ]),
            Vocabulary() {
                return {
                    "percent": "{value}% del Botín",
                    "settings": "Código del Capitán",
                    "fullscreen": "Pantalla completa",
                    "speed": "Velocidad",
                    "play": "Play",
                    "pause": "Pausa",
                    "open": "Abrir",
                    "close": "Cerrar",
                    "pictureInPicture": "Cuadro por cuadro",
                    "appleAirplay": "Apple AirPlay",
                    "googleCast": "Google Cast",
                    "vr": "Cofa Virtual",
                    "off": "Off",
                    "auto": "auto",
                    "ecoMode": "Raciones del Pirata",
                    "ecoMode.title": "Modo de Ración",
                    "replay": "Repetir",
                    "normal": "Normal",
                    "live": "En vivo",
                    "playingOn": "Reproduciendo en <strong>{castDeviceName}</strong>, ¡arrr!",
                    "connectingTo": "Conectando con <strong>{castDeviceName}</strong>...",
                    "watermarkLink": "Enlace a la Guarida del Capitán",
                    "controlBar": "Timón del Barco",
                    "player": "Reproductor",
                    "seekBar": "Barra de búsqueda",
                    "font size": "Tamaño de letra",
                    "font style": "Estilo de letra",
                    "font family": "Tipografía",
                    "font color": "Color de letra",
                    "font opacity": "Opacidad de letra",
                    "Character edge": "Borde del carácter",
                    "Character edge color": "Color de borde del carácter",
                    "Background color": "Color de fondo",
                    "Background opacity": "Opacidad de fondo",
                    "Window color": "Color de ventana",
                    "Window opacity": "Opacidad de ventana",
                    "Back": "Atrás",
                    "Reset": "Reiniciar",
                    "Default": "Predeterminado",
                    "Italic": "Cursiva",
                    "Bold": "Negrita",
                    "Monospaced serif": "Monospaced Serif",
                    "Proportional serif": "Proportional Serif",
                    "Monospaced sans serif": "Monospaced Sans Serif",
                    "Proportional sans serif": "Proportional Sans Serif",
                    "Casual": "Casual",
                    "Cursive": "Cursiva",
                    "Small capital": "Small Capital",
                    "White": "Blanco",
                    "Black": "Negro",
                    "Red": "Rojo",
                    "Green": "Verde",
                    "Blue": "Azul",
                    "Cyan": "Cian",
                    "Yellow": "Amarillo",
                    "Magenta": "Magenta",
                    "Raised": "Elevado",
                    "Depressed": "Depressed",
                    "Uniform": "Uniforme",
                    "Drop shadowed": "Sombra paralela",
                    "transparent": "Transparente",
                    "settings.subtitles.font.size": "Tamaño de letra",
                    "settings.subtitles.font.style": "Estilo de letra",
                    "settings.subtitles.font.family": "Tipografía",
                    "settings.subtitles.font.color": "Color de letra",
                    "settings.subtitles.font.opacity": "Opacidad de letra",
                    "settings.subtitles.background.color": "Color de fondo",
                    "settings.subtitles.background.opacity": "Opacidad de fondo",
                    "settings.subtitles.window.color": "Color de ventana",
                    "settings.subtitles.window.opacity": "Opacidad de ventana",
                    // Font style / family values:
                    "settings.subtitles.font.family.monospacedserif": "Monospaced Serif",
                    "settings.subtitles.font.family.proportionalserif": "Proportional Serif",
                    "settings.subtitles.font.family.monospacedsansserif": "Monospaced Sans Serif",
                    "settings.subtitles.font.family.proportionalsansserif": "Proportional Sans Serif",
                    "settings.subtitles.font.family.casual": "Casual",
                    "settings.subtitles.font.family.cursive": "Cursiva",
                    "settings.subtitles.font.family.smallcapital": "Small Capital",

                    // Colors (optional to keep overriding):
                    "colors.white": "Blanco",
                    "colors.black": "Negro",
                    "colors.red": "Rojo",
                    "colors.green": "Verde",
                    "colors.blue": "Azul",
                    "colors.cyan": "Cian",
                    "colors.yellow": "Amarillo",
                    "colors.magenta": "Magenta",

                    // Character edge:
                    "character edge color": "Color de borde del caracteres",
                    "Character edge color": "Color de borde del caracteres",
                    "Character Edge Color": "Color de borde del caracteres", 
                    "settings.subtitles.character Edge Color": "Color del borde de caracteres",         
                    "settings.subtitles.character Edge": "Borde del carácter",
                    "settings.subtitles.character Edge Color": "Color del borde de caracteres",
                    "settings.subtitles.characterEdgeColor": "Color del borde de caracteres",
                    "settings.subtitles.characteredgecolor": "Color del borde de caracteres",
                    "settings.subtitles.character Edge.raised": "Elevado",
                    "settings.subtitles.character Edge.depressed": "Depressed",
                    "settings.subtitles.character Edge.uniform": "Uniforme",
                    "settings.subtitles.character Edge.dropshadowed": "Sombra paralela",

                    "default": "Predeterminado",
                    "reset": "Reiniciar",
                    "back": "Atrás",
                    "transparent": "Transparente",
                }
            },
            setupPlayer(contentInformation) {
                this.flushPlaybackAnalytics();
                this.analyticsSession = new PlaybackWatchSession(contentInformation);
                this.intervalId = null;
                console.log('setupPlayer', contentInformation);
                this.nextItem = null;
                this.showNextPopup = false;
                this.countdown = 10;
                clearInterval(this.countdownTimer);
                console.log('contentInformation', contentInformation);
                if(contentInformation?.drmTokenResp?.reason) {
                    // alert(contentInformation.drmTokenResp.reason);
                    this.errorMessage = contentInformation.drmTokenResp.reason;
                }
                this.programsData = [];
                const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                // if (window.bmPlayer) {
                //     window.bmPlayer = new bitmovin.player.Player(this.$refs.player, this.playerConfig);
                // }
                let source = {
                    title: contentInformation.title,
                    poster: this.getLowPoster(contentInformation),
                };
                if(contentInformation.isStartOver) {
                    source['options'] = {
                        startOffset: 0, // Start 30 seconds into the content
                        startOffsetTimelineReference: "start" 
                    }
                }
                if (contentInformation?.drmTokenResp?.drmprovider == "FTACHANNEL") {
                    contentInformation.mmStreamUrl = contentInformation.streamfilename || contentInformation?.streamUrl || contentInformation?.streamurl || contentInformation?.drmTokenResp?.streamurl;
                    source.hls = contentInformation.streamfilename || contentInformation?.streamUrl || contentInformation?.streamurl || contentInformation?.drmTokenResp?.streamurl;
                    source.drm = {
                    }
                } else if(contentInformation?.drmTokenResp?.drmprovider == "NoDRM") {
                    if(contentInformation?.drmTokenResp?.playbackDetails?.playbackUrls?.[0]) {
                        if(contentInformation?.drmTokenResp?.playbackDetails?.playbackUrls?.[0]?.protocol == "HLS") {
                            contentInformation.mmStreamUrl = contentInformation.streamfilename || contentInformation?.streamUrl || contentInformation?.streamurl || contentInformation?.drmTokenResp?.streamurl || contentInformation?.drmTokenResp?.playbackDetails?.playbackUrls?.[0].playbackUrl;
                            source.hls = contentInformation.streamfilename || contentInformation?.streamUrl || contentInformation?.streamurl || contentInformation?.drmTokenResp?.streamurl || contentInformation?.drmTokenResp?.playbackDetails?.playbackUrls?.[0].playbackUrl;
                        } else {
                            contentInformation.mmStreamUrl = contentInformation.streamfilename || contentInformation?.streamUrl || contentInformation?.streamurl || contentInformation?.drmTokenResp?.streamurl || contentInformation?.drmTokenResp?.playbackDetails?.playbackUrls?.[0].playbackUrl;
                            source.dash = contentInformation.streamfilename || contentInformation?.streamUrl || contentInformation?.streamurl || contentInformation?.drmTokenResp?.streamurl || contentInformation?.drmTokenResp?.playbackDetails?.playbackUrls?.[0].playbackUrl;
                        }
                    }
                } else if (contentInformation?.drmTokenResp?.drmprovider == "AXINOM") {
                    let streamUrl = this.checkForCatchUpOrStartOver(contentInformation);
                    if (isSafari) {
                        contentInformation.mmStreamUrl = streamUrl || contentInformation?.drmTokenResp?.streamurl || contentInformation.streamfilename || contentInformation?.streamUrl || contentInformation?.streamurl;
                        source.hls = streamUrl || contentInformation.streamfilename || contentInformation?.streamUrl || contentInformation?.streamurl || contentInformation?.drmTokenResp?.streamurl;
                        source.drm = {
                            fairplay: {
                                LA_URL: `${contentInformation?.drmTokenResp?.axinomplaybackDetails?.licence_url}?AxDrmMessage=${contentInformation?.drmTokenResp?.axinomplaybackDetails?.licenceToken}`,
                                certificateURL: 'https://mvshub.com.ar/certificates/fairplay.crt',
                                headers: {
                                    'Content-type': 'application/octet-stream',
                                },
                                prepareContentId: (initDataUri) => {
                                    const uri = typeof initDataUri === 'string'
                                        ? initDataUri
                                        : String.fromCharCode.apply(null, new Uint8Array(initDataUri || []));

                                    const skdMatch = uri.match(/skd:\/\/(.+)/);
                                    return skdMatch?.[1] || uri;
                                },
                                prepareLicenseAsync: (ckc) => {
                                    // return ckc;
                                    return new Promise((resolve, reject) => {
                                        const reader = new FileReader();
                                        reader.onloadend = () => resolve(new Uint8Array(reader.result));
                                        reader.onerror = () => reject(reader.error);
                                        reader.readAsArrayBuffer(ckc);
                                    });
                                },
                                prepareMessage: (event) => {
                                    // return event;
                                    return new Blob([event.message], { type: 'application/octet-stream' });
                                },
                                useUint16InitData: true,
                                licenseResponseType: 'blob'
                            }
                        }
                    } else {
                        contentInformation.mmStreamUrl = streamUrl || contentInformation.streamfilename || contentInformation?.streamUrl || contentInformation?.streamurl || contentInformation?.drmTokenResp?.streamurl;
                        source.dash = streamUrl || contentInformation?.streamfilename || contentInformation?.streamUrl || contentInformation?.streamurl || contentInformation?.drmTokenResp?.streamurl;
                        source.drm = {
                            widevine: {
                                LA_URL: `${contentInformation?.drmTokenResp?.axinomplaybackDetails?.licence_url}?AxDrmMessage=${contentInformation?.drmTokenResp?.axinomplaybackDetails?.licenceToken}`
                            }
                        }
                    }
                } else if (contentInformation?.drmTokenResp?.drmprovider == "EZDRM") {
                    const playbackUrl = contentInformation?.drmTokenResp?.playbackDetails?.playbackUrls?.[0]?.playbackUrl;
                    const certificateUrl = contentInformation?.drmTokenResp?.playbackDetails?.playbackUrls?.[0]?.certificateUrl;
                    const customData = contentInformation?.drmTokenResp?.playbackDetails?.playbackUrls?.[0]?.customData;
                    if (isSafari) {
                        contentInformation.mmStreamUrl = playbackUrl || contentInformation.streamfilename || contentInformation?.streamUrl || contentInformation?.streamurl || contentInformation?.drmTokenResp?.streamurl;
                        source.hls = playbackUrl || contentInformation.streamfilename || contentInformation?.streamUrl || contentInformation?.streamurl || contentInformation?.drmTokenResp?.streamurl;
                        source.drm = {
                            fairplay: {
                                LA_URL: `${process.env.VUE_APP_LICEANCE_PROXYURL}?license-token=${contentInformation?.drmTokenResp?.playbackDetails["license-token"]}&secret-key-id=${contentInformation?.drmTokenResp?.playbackDetails["license-secret-key-id"]}`,
                                certificateURL: certificateUrl,
                                headers: {
                                    'Content-type': 'application/octet-stream',
                                    "x-ses-params": customData?.["x-ses-params"],
                                    "x-ses-user-token": customData?.["x-ses-user-token"],
                                    "x-ses-user-token-secret-key-id": customData?.["x-ses-user-token-secret-key-id"],
                                    "X-SESSION": `${localStorage.getItem("sessionToken")}`
                                },
                                prepareContentId: (contentId) => {
                                    let uri = contentId;
                                    let uriParts = uri.split('://', 1);
                                    let protocol = uriParts[0].slice(-3);
                                    uriParts = uri.split(';', 2);
                                    contentId = uriParts.length>1?uriParts[1]:'';
                                    return protocol.toLowerCase()=='skd' ? contentId : '';
                                },
                                prepareLicenseAsync: (ckc) => {
                                    return new Promise((resolve, reject) => {
                                        let reader = new FileReader();
                                        reader.addEventListener('loadend', () => {
                                        let array = new Uint8Array(reader.result);
                                        resolve(array);
                                    });
                                    reader.addEventListener('error', () => {
                                        reject(reader.error);
                                    });
                                    reader.readAsArrayBuffer(ckc);
                                    });
                                },
                                prepareMessage: (event, session) => {
                                    return new Blob([event.message], {type: 'application/octet-binary'});
                                },
                                useUint16InitData: true,
                                licenseResponseType: 'blob'
                            }
                        }
                    } else {
                        contentInformation.mmStreamUrl = playbackUrl || contentInformation.streamfilename || contentInformation?.streamUrl || contentInformation?.streamurl || contentInformation?.drmTokenResp?.streamurl;
                        source.dash = playbackUrl || contentInformation.streamfilename || contentInformation?.streamUrl || contentInformation?.streamurl || contentInformation?.drmTokenResp?.streamurl;
                        source.drm = {
                            widevine: {
                                LA_URL: `${process.env.VUE_APP_LICEANCE_PROXYURL}?license-token=${contentInformation?.drmTokenResp?.playbackDetails["license-token"]}&secret-key-id=${contentInformation?.drmTokenResp?.playbackDetails["license-secret-key-id"]}`,
                                headers: {
                                    "x-ses-params": customData?.["x-ses-params"],
                                    "x-ses-user-token": customData?.["x-ses-user-token"],
                                    "x-ses-user-token-secret-key-id": customData?.["x-ses-user-token-secret-key-id"],
                                    "X-SESSION": `${localStorage.getItem("sessionToken")}`
                                },
                            }
                        };
                    }
                } else if (contentInformation?.drmTokenResp?.drmprovider == "CDRM2") {
                    const playbackUrl = contentInformation?.drmTokenResp?.playbackDetails?.playbackUrls?.[0]?.playbackUrl;
                    const customData = contentInformation?.drmTokenResp?.playbackDetails?.playbackUrls?.[0]?.customData;
                    const certificateUrl = contentInformation?.drmTokenResp?.playbackDetails?.playbackUrls?.[0]?.certificateUrl;
                    if (isSafari) {
                        contentInformation.mmStreamUrl = playbackUrl || contentInformation.streamfilename || contentInformation?.streamUrl || contentInformation?.streamurl || contentInformation?.drmTokenResp?.streamurl;
                        source.hls = playbackUrl || contentInformation.streamfilename || contentInformation?.streamUrl || contentInformation?.streamurl || contentInformation?.drmTokenResp?.streamurl;
                        source.drm = {
                            fairplay: {
                                // LA_URL: `${process.env.VUE_APP_LICEANCE_PROXYURL}?license-token=${contentInformation?.drmTokenResp?.playbackDetails["license-token"]}&secret-key-id=${contentInformation?.drmTokenResp?.playbackDetails["license-secret-key-id"]}`,
                                certificateURL: certificateUrl || 'https://mvshub.com.ar/certificates/fairplay.crt',
                                headers: {
                                    "Content-Type": "application/octet-stream",
                                    "x-ses-params": customData?.["x-ses-params"],
                                    "x-ses-user-token": customData?.["x-ses-user-token"],
                                    "x-ses-user-token-secret-key-id": customData?.["x-ses-user-token-secret-key-id"],
                                    "X-SESSION": `${localStorage.getItem("sessionToken")}`
                                },
                                useUint16InitData: true, 
                                licenseResponseType: "blob", 
                                getLicenseServerUrl: function (contentId) { 
                                    const pattern = "//"; 
                                    const idx = contentId.indexOf(pattern); 
                                    const assetId = contentId.substring(idx + pattern.length); 
                                    const result = `${process.env.VUE_APP_LICEANCE_PROXYURL}?license-token=${contentInformation?.drmTokenResp?.playbackDetails["license-token"]}&secret-key-id=${contentInformation?.drmTokenResp?.playbackDetails["license-secret-key-id"]}&assetId=${encodeURIComponent(assetId)}`; 
                                    return result; 
                                }, 
                                prepareContentId: function (contentId) { 
                                    const pattern = "//"; 
                                    const idx = contentId.indexOf(pattern); 
                                    const assetId = contentId.substring(idx + pattern.length); 
                                    return encodeURIComponent(assetId); 
                                }, 
                                prepareMessage: function (keyMessageEvent) { 
                                    return new Blob([keyMessageEvent.message], { 
                                    type: "application/octet-binary", 
                                }); 
                                }, 
                                prepareLicenseAsync: (ckc) => { 
                                    return new Promise((resolve, reject) => { 
                                        const reader = new FileReader(); 
                                        reader.addEventListener("loadend", () => { 
                                        const array = new Uint8Array(reader.result); 
                                        resolve(array); 
                                    }); 
                                    reader.addEventListener("error", () => { 
                                    reject(reader.error); 
                                    }); 
                                    reader.readAsArrayBuffer(ckc); 
                                    });
                                }
                            }
                        }
                    } else {
                        contentInformation.mmStreamUrl = playbackUrl || contentInformation.streamfilename || contentInformation?.streamUrl || contentInformation?.streamurl || contentInformation?.drmTokenResp?.streamurl;
                        source.dash = playbackUrl || contentInformation.streamfilename || contentInformation?.streamUrl || contentInformation?.streamurl || contentInformation?.drmTokenResp?.streamurl;
                        source.drm = {
                            widevine: {
                                LA_URL: `${process.env.VUE_APP_LICEANCE_PROXYURL}?license-token=${contentInformation?.drmTokenResp?.playbackDetails["license-token"]}&secret-key-id=${contentInformation?.drmTokenResp?.playbackDetails["license-secret-key-id"]}`,
                                headers: {
                                    "x-ses-params": customData?.["x-ses-params"],
                                    "x-ses-user-token": customData?.["x-ses-user-token"],
                                    "x-ses-user-token-secret-key-id": customData?.["x-ses-user-token-secret-key-id"],
                                    "X-SESSION": `${localStorage.getItem("sessionToken")}`
                                }
                            }
                        };
                    }
                }
                source.labeling = {
                    dash: {
                        qualities: this.getQualityLabels,
                        // subtitles: this.getSubtitleLabels,
                        // tracks: this.getTrackLabels
                    }
                }
                source.labeling.hls = source.labeling.dash;
                this.bitmovinMMSSIntegration(contentInformation, window.bmPlayer, null,  window.playerEvent, this.viewSessionId);
                return window?.bmPlayer?.load(source).then(() => {
                    // Create UI instance
                    window.uiManager = new bitmovin.playerui.UIManager(window.bmPlayer, this.createUIContainer(contentInformation));
                    this.nextPrevChannelHideShow = true;
                    this.$nextTick(() => {
                        this.prevChannelDisplay = { ...this.prevChannelDisplay };
                        this.nextChannelDisplay = { ...this.nextChannelDisplay };
                    });
                    window.mmBitmovinPlugin.reportCustomMetadata("custom_3", contentInformation?.drmTokenResp?.drmscheme?.[0]);
                    if(contentInformation.objecttype == "CHANEL" || contentInformation.objecttype == "EPGPROGRAMME") {
                        window.mmBitmovinPlugin.reportCustomMetadata("custom_4", (contentInformation.title || contentInformation.defaulttitle));
                        window.mmBitmovinPlugin.reportCustomMetadata("custom_5", contentInformation.channelno);
                    }
                    return "success"
                }).catch((error) => {
                    window.uiManager = new bitmovin.playerui.UIManager(window.bmPlayer, this.createUIContainer(contentInformation));
                    this.$nextTick(() => {
                        this.prevChannelDisplay = { ...this.prevChannelDisplay };
                        this.nextChannelDisplay = { ...this.nextChannelDisplay };
                    });
                    console.log('Error while loading source', error);
                    return "failed"
                });
            },
            destroyPlayer() {
                if (window.bmPlayer) {
                    if (window.bmPlayer._internalIntervals) {
                        window.bmPlayer._internalIntervals.forEach(clearInterval);
                    }
                    window.bmPlayer.off();
                    window.bmPlayer.unload();
                    window.bmPlayer.destroy();
                    window.bmPlayer = null;
                    if (this.$refs.playerContainer) {
                        this.$refs.playerContainer.innerHTML = '';
                    }
                }
            },
            createUIContainer(contentInfo) {
                // seek interval in seconds
                const interval = 20;
                let channelLogoOverlay = null;
                let nextChannelLogoOverlay = null;
                let prevChannelLogoOverlay = null;
                let nextContentOverlay = null;
                if (contentInfo.objecttype === "CHANEL" || contentInfo.category === "TVCHANEL") {
                    channelLogoOverlay = new bitmovin.playerui.Button({
                        text: `<img src="${this.getLowPoster(contentInfo)}" class="bmpui-channel-logo-img" />`,
                        cssClass: 'ui-channel-logo-overlay'
                    });
                    nextChannelLogoOverlay = new bitmovin.playerui.Button({ cssClass: 'ui-next-channel-button bmpui-ui-button' });
                    nextChannelLogoOverlay.onClick.subscribe(async () => {
                        await this.actNextChannelChange();
                    });
                    prevChannelLogoOverlay = new bitmovin.playerui.Button({ cssClass: 'ui-prev-channel-button bmpui-ui-button' });
                    prevChannelLogoOverlay.onClick.subscribe(async () => {
                        await this.actPrevChannelChange();
                    });
                };
                let closeButton = new bitmovin.playerui.Button({cssClass: 'ui-closebutton bmpui-ui-button'});
                closeButton.onClick.subscribe(async () => {
                    await this.actClosePlayer();
                });
                let rewindButton = null;
                let forwardButton = null;
                let restartButton = null;
                let goLiveButton = null;
                if(contentInfo.objecttype !== "CHANEL" || contentInfo?.program?.isCatchUp){
                    rewindButton = new bitmovin.playerui.Button({cssClass: 'ui-rewindbutton bmpui-ui-button'});
                    rewindButton.onClick.subscribe(function () {
                        window.bmPlayer.seek(Math.max(0, window.bmPlayer.getCurrentTime() - interval));
                    });

                    forwardButton = new bitmovin.playerui.Button({cssClass: 'ui-forwardbutton bmpui-ui-button'});
                    forwardButton.onClick.subscribe(function () {
                        window.bmPlayer.seek(Math.min(window.bmPlayer.getDuration(), window.bmPlayer.getCurrentTime() + interval));
                    });
                    nextContentOverlay = new bitmovin.playerui.Button({cssClass: 'ui-next-content-button bmpui-ui-button'});
                    nextContentOverlay.onClick.subscribe(async () => {
                        await this.playNextNow()();
                    });
                }

                let playListButton = new bitmovin.playerui.Button({ cssClass: 'ui-listbutton bmpui-ui-button'});
                playListButton.onClick.subscribe(async () => {
                    await this.actShowPlaylist(true);
                });
                if(contentInfo?.contentprovider == "CATCHUPTV" || contentInfo?.objecttype == "EPGPROGRAMME" || contentInfo?.program?.isCatchUp) {
                    goLiveButton = new bitmovin.playerui.Button({text: 'Go Live', cssClass: 'ui-goLiveButton bmpui-ui-button'});
                    goLiveButton.onClick.subscribe(async () => {
                        await this.actGoLive(contentInfo);
                    });
                }
                if(contentInfo.objecttype === "CHANEL" && !contentInfo?.program?.isCatchUp){
                    restartButton = new bitmovin.playerui.Button({cssClass: 'ui-restartbutton bmpui-ui-button'});
                    restartButton.onClick.subscribe(async () => {
                        await this.actStartOverPlayBack(contentInfo);
                    });
                }   
                let subtitleOverlay = new bitmovin.playerui.SubtitleOverlay();
                let mainSettingsPanelPage = new bitmovin.playerui.SettingsPanelPage({
                    components: [
                        new bitmovin.playerui.SettingsPanelItem(this.localDisplayLang == 'es' ? 'Calidad de video' : 'Video Quality', new bitmovin.playerui.VideoQualitySelectBox()),
                        ...(this.liveplayerpayload.category !== "TVCHANEL" 
                            ? [new bitmovin.playerui.SettingsPanelItem(this.localDisplayLang == 'es' ? 'velocidad' : 'Speed', new bitmovin.playerui.PlaybackSpeedSelectBox())] 
                            : []),
                        new bitmovin.playerui.SettingsPanelItem(this.localDisplayLang == 'es' ? 'velocidad' : 'Audio quality', new bitmovin.playerui.AudioQualitySelectBox()),
                        new bitmovin.playerui.SettingsPanelItem(this.localDisplayLang == 'es' ? 'Pista de audio' : 'Audio track', new bitmovin.playerui.AudioTrackSelectBox()),
                    ],
                });
                let settingsPanel = new bitmovin.playerui.SettingsPanel({
                    components: [
                        mainSettingsPanelPage,
                    ],
                    hidden: true,
                });
                let subtitleSettingsPanelPage = new bitmovin.playerui.SubtitleSettingsPanelPage({
                    settingsPanel: settingsPanel,
                    overlay: subtitleOverlay,
                });

                const subtitleSelectBox = new bitmovin.playerui.SubtitleSelectBox();

                let subtitleSettingsOpenButton = new bitmovin.playerui.SettingsPanelPageOpenButton({
                    targetPage: subtitleSettingsPanelPage,
                    container: settingsPanel,
                    ariaLabel: this.localDisplayLang == 'es' ? 'Subtítulos' : 'Subtitles',
                    text: 'open',
                });

                mainSettingsPanelPage.addComponent(
                    new bitmovin.playerui.SettingsPanelItem(
                        new bitmovin.playerui.SubtitleSettingsLabel({
                            text: this.localDisplayLang == 'es' ? 'Subtítulos' : 'Subtitles',
                            opener: subtitleSettingsOpenButton,
                        }),
                        subtitleSelectBox,
                        {
                            role: 'menubar',
                        },
                    ));

                settingsPanel.addComponent(subtitleSettingsPanelPage);

                let controlBar = new bitmovin.playerui.ControlBar({
                    components: [
                        settingsPanel,
                        // new bitmovin.playerui.Container({
                        //     components: [
                        //         ...(nextContentOverlay ? [nextContentOverlay] : []),
                        //     ],
                        //     cssClasses: ['next-content-container'],
                        // }),
                        ...((contentInfo.objecttype === "CHANEL" || contentInfo.category === "TVCHANEL") ? [new bitmovin.playerui.Container({
                            components: [
                                ...(prevChannelLogoOverlay ? [prevChannelLogoOverlay] : []),
                                ...(channelLogoOverlay ? [channelLogoOverlay] : []),
                                ...(nextChannelLogoOverlay ? [nextChannelLogoOverlay]  : [])
                            ],
                            cssClasses: ['channel-logo-container'],
                        })] : []),
                        new bitmovin.playerui.Container({
                            components: [
                                new bitmovin.playerui.PlaybackToggleButton(),
                               ...(rewindButton ? [rewindButton] : []),
                                ...(forwardButton ? [forwardButton] : []),
                                ...(restartButton ? [restartButton] : []),
                                new bitmovin.playerui.VolumeToggleButton(),
                                new bitmovin.playerui.VolumeSlider(),
                                new bitmovin.playerui.Spacer(),
                                new bitmovin.playerui.PictureInPictureToggleButton(),
                                new bitmovin.playerui.AirPlayToggleButton(),
                                new bitmovin.playerui.CastToggleButton(),
                                new bitmovin.playerui.VRToggleButton(),
                                new bitmovin.playerui.SettingsToggleButton({settingsPanel: settingsPanel}),
                                ...(goLiveButton ? [goLiveButton] : []),
                                new bitmovin.playerui.FullscreenToggleButton(),
                            ],
                            cssClasses: ['controlbar-top'],
                        }),
                        new bitmovin.playerui.Container({
                            components: [
                                new bitmovin.playerui.PlaybackTimeLabel({
                                    timeLabelMode: bitmovin.playerui.PlaybackTimeLabelMode.CurrentTime,
                                    hideInLivePlayback: true
                                }),
                                new bitmovin.playerui.SeekBar({label: new bitmovin.playerui.SeekBarLabel()}),
                                new bitmovin.playerui.PlaybackTimeLabel({
                                    timeLabelMode: bitmovin.playerui.PlaybackTimeLabelMode.TotalTime,
                                    cssClasses: ['text-right']
                                }),
                            ],
                            cssClasses: ['controlbar-bottom'],
                        }),
                    ],
                });

                return new bitmovin.playerui.UIContainer({
                    components: [
                        subtitleOverlay,
                        new bitmovin.playerui.BufferingOverlay(),
                        new bitmovin.playerui.PlaybackToggleOverlay(),
                        new bitmovin.playerui.CastStatusOverlay(),
                        new bitmovin.playerui.Container({
                            components: [
                                ...(nextContentOverlay ? [nextContentOverlay] : []),
                            ],
                            cssClasses: ['next-content-container'],
                        }),
                        controlBar,
                        new bitmovin.playerui.TitleBar({
                            components: [
                                playListButton,
                                new bitmovin.playerui.MetadataLabel({
                                content: bitmovin.playerui.MetadataLabelContent.Title
                                }),
                                closeButton,
                            ]
                        }),
                        new bitmovin.playerui.RecommendationOverlay(),
                        // new bitmovin.playerui.ErrorMessageOverlay(),
                    ],
                    hideDelay: 2000,
                    hidePlayerStateExceptions: [
                        bitmovin.playerui.PlayerUtils.PlayerState.Prepared,
                        bitmovin.playerui.PlayerUtils.PlayerState.Paused,
                        bitmovin.playerui.PlayerUtils.PlayerState.Finished,
                        bitmovin.playerui.PlayerUtils.PlayerState.Idle,
                    ],
                });
            },
            async actClosePlayer() {
                this.pauseTimer();
                window.activeChanelProgramsListAll = [];
                window.activeChanelProgramsList = [];
                window.totalAllCategorycount = 0;
                let contentData = {...this.liveplayerpayload};
                this.unsetStreamApiCall(contentData);
                contentData.position = window.bmPlayer.getCurrentTime() || 0;
                console.log("<-- THECONTINUE WATCH UPDATE TO THE FIREBASE --> Hello", contentData);
                this.updateDataOnFirebase(contentData).then((data) => {
                    console.log("<-- THECONTINUE WATCH UPDATE TO THE FIREBASE -->", data);
                    eventBus.$emit("check-new-fire-data", true);
                }).catch((err) => { alert('error') });
                this.liveplayerpayload = null;
                await this.destroyPlayer();
                this.$emit("actCloseLivePlayer", true);
            },
            async actStartOverPlayBack(liveplayerpayload) {
                console.log("contentData_", liveplayerpayload);
                await this.updateDataOnFirebase({ ...this.liveplayerpayload });
                liveplayerpayload = { ...liveplayerpayload, isRestart: true, isStartOver: true, watchedduration: 0 };
                this.userActionEvent({ ...playbackIdentity(liveplayerpayload, this.currentChannelDisplay || {}), action_name: "RESTART" });
                window.uiManager.release();
                window.bmPlayer.unload();
                // window.bmPlayer.off(bitmovin.player.PlayerEvent.SourceLoaded, this.onSourceLoadedHandler);
                // window.bmPlayer.off(bitmovin.player.PlayerEvent.SourceLoaded, this.onPlayerReadyHandler);
                // this.setupPlayer(liveplayerpayload);
                const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                // this.content.watchedTime = await this.getContentProgress(this.content);
                let uriData = null;
                const urlencoded = new URLSearchParams();
                if(isSafari) {
                    uriData = await this.parseHlsManifest(liveplayerpayload.streamUrl);
                    if(uriData) {
                        urlencoded.append("keyid", uriData[0]);
                        urlencoded.append("keyiv", uriData[1]);
                    }
                }
                urlencoded.append("contentid", liveplayerpayload.channelid || liveplayerpayload.objectid);
                urlencoded.append("ios", isSafari ? true : false);
                urlencoded.append("seclevel", "SW");
                let drmPromise = store.dispatch("actGetDRMToken", urlencoded);
                let firePromise = Promise.resolve(true);
                return Promise.all([drmPromise, firePromise])
                .then(async ([drmRes, fireRes]) => {

                    // Both promises have resolved successfully
                    console.log("Firebase update result:", fireRes);

                    // Emit the event
                    eventBus.$emit("check-new-fire-data", true);
                    let contentData = {...liveplayerpayload};
                    contentData['drmTokenResp'] = drmRes.data;
                    contentData['isStartOver'] = true;
                    window.uiManager.release();
                    this.liveplayerpayload = contentData;
                    console.log("contentData", contentData);
                    window.bmPlayer.unload();
                    this.setupPlayer(contentData)
                })
                .catch((err) => {
                    console.log("err", err);
                });
            },
            checkForCatchUpOrStartOver(program) {
                let programStartTime = "";
                let programEndTime = "";
                let isItCatchupContent = this.isCatchupContent(program?.publishtime, program?.endtime);
                let publishtime = program?.program?.start || program?.publishtime;
                let programStart = program?.program?.start ? moment.utc(moment(publishtime, "YYYYMMDDHHmmss Z")).format("YYYY-MM-DD HH:mm:ss") : moment.utc(moment(program?.publishtime, "YYYY-MM-DD HH:mm:ss")).local().format("YYYY-MM-DD HH:mm:ss");
                programStart = moment.utc(programStart, "YYYY-MM-DD HH:mm:ss");
                programStartTime = (programStart.valueOf() * 10000).toString();
                let endTime = program?.program?.stop || program?.endtime;
                let programEnd = program?.program?.stop ? moment.utc(moment(endTime, "YYYYMMDDHHmmss Z")).format("YYYY-MM-DD HH:mm:ss") : moment.utc(moment(program?.endtime, "YYYY-MM-DD HH:mm:ss")).local().format("YYYY-MM-DD HH:mm:ss");
                programEnd = moment.utc(programEnd, "YYYY-MM-DD HH:mm:ss");
                programEndTime = (programEnd.valueOf() * 10000).toString();
                let stremUrlData = program?.drmTokenResp?.streamurl || program?.streamUrl || program?.streamurl || program.streamfilename;
                let convertedUrl = stremUrlData;
                if ((program?.program && program?.program?.isCatchUp && program?.program?.start && program?.program?.stop) || (isItCatchupContent && (program?.contentprovider == "CATCHUPTV" || program?.objecttype == "EPGPROGRAMME"))) {
                    this.isPlayBackTypeLive = false;
                    convertedUrl = this.createAxinomCatchUpURL(stremUrlData, programStartTime, programEndTime, true);
                } else {
                    if(program.isStartOver) {
                        this.isPlayBackTypeLive = false;
                        convertedUrl = this.createAxinomCatchUpURL(stremUrlData, programStartTime, programEndTime, false);
                    }
                    else {
                        if (program.category == "TVCHANEL") {
                            self.isPlayBackTypeLive = true;
                        }
                    }
                }
                return convertedUrl;
            },
            createAxinomCatchUpURL(baseURL, startTime, endTime, isCatchup) {    
                const regex = /channel\(([^)]+)\)/;
                const match = baseURL.match(regex);

                if (match && match[1]) {
                const channelName = match[1];
                let convertPart = "";
                if(isCatchup) {
                    convertPart = `CatchUp/channel(name=${channelName},startTime=${startTime},endTime=${endTime})`;
                } else {
                    convertPart = `StartOver/channel(name=${channelName},startTime=${startTime})`;
                }
                const modifiedURL = baseURL.replace(
                    `Live/channel(${channelName})`,
                    convertPart
                );
                // https://dish-arg.akamaized.net/Content/DASH/CatchUp/channel(name=lanacion_arg,startTime=17602632000000000,endTime=17602740000000000)/manifest.mpd
                // https://dish-arg.akamaized.net/Content/DASH/CatchUp/channel(name=lanacion_arg,startTime=17602632000000000,endTime=17602740000000000)/manifest.mpd
                // https://dish-arg.akamaized.net/Content/DASH/StartOver/channel(name=lanacion_arg,startTime=17458848000000000)/manifest.mpd
                // https://dish-arg.akamaized.net/Content/DASH/StartOver/channel(name=lanacion_arg,startTime=17602740000000000)/manifest.mpd
                return modifiedURL.replace('variant.mpd', 'manifest.mpd');
                // return modifiedURL;
                }

                return null;
            },
            isCatchupContent(startUtc, endUtc) {
                // Convert UTC strings to moment objects in UTC
                const startTime = moment.utc(startUtc);
                const endTime = moment.utc(endUtc);

                // Convert to local time
                const localStart = startTime.local();
                const localEnd = endTime.local();
                const now = moment(); // already in local time

                // Determine content type
                let contentType = false;
                if (localEnd.isBefore(now)) {
                    contentType = true;
                } else if (localStart.isBefore(now) && localEnd.isAfter(now)) {
                    contentType = false;
                } else {
                    contentType = false;
                }
                return contentType;
            },
            getLowPoster(item) {
                let returnImage = this.placeHolder.landScape;
                if (item.thumbnail) {
                    return item.thumbnail;
                } else if (
                        item &&
                        item.poster &&
                        item.poster.length
                    ) {
                    let index =
                        item &&
                        item.poster &&
                        item.poster.findIndex((data) => {
                        return data.postertype === "LANDSCAPE";
                        });
                    if (index > -1) {
                        item.poster[index].filelist.filter((lowImg) => {
                        if (lowImg && lowImg.quality === "LOW" || lowImg.quality === "SD" || lowImg.quality === "HD")  {
                            returnImage = lowImg.filename;
                        }
                        });
                    }
                }
                return returnImage;
            },
            actShowPlaylist(val) {
                this.channelListActive = !this.channelListActive;
                this.showPlaylist = !this.showPlaylist;
                if(val) {
                    window.bmPlayer.pause();  // pauses playback
                } else {
                    window.bmPlayer.play();   // starts/resumes playback
                }
            },
            async actNextChannelChange() {
                this.nextPrevChannelHideShow = false;
                let found = false;
                this.isPlayActive = true;
                let Num = 0;
                for (let index in window.activeChanelProgramsListAll) {
                    Num = Number(index);
                    if (
                        window.activeChanelProgramsListAll[Num].objectid ==
                        this.currentChannelDisplay.objectid
                    ) {
                        found = true;
                        this.nextChannelDisplay = window.activeChanelProgramsListAll[Num + 2]
                            ? window.activeChanelProgramsListAll[Num + 2]
                            : {};
                        this.prevChannelDisplay = window.activeChanelProgramsListAll[Num]
                            ? window.activeChanelProgramsListAll[Num]
                            : {};
                        this.currentChannelDisplay = window.activeChanelProgramsListAll[
                            Num + 1
                        ]
                            ? window.activeChanelProgramsListAll[Num + 1]
                            : {};

                        break;
                    }
                }
                const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                // this.content.watchedTime = await this.getContentProgress(this.content);
                let uriData = null;
                const urlencoded = new URLSearchParams();
                if(isSafari) {
                    uriData = await this.parseHlsManifest(this.currentChannelDisplay.streamUrl);
                    if(uriData) {
                        urlencoded.append("keyid", uriData[0]);
                        urlencoded.append("keyiv", uriData[1]);
                    }
                }
                urlencoded.append("contentid", this.currentChannelDisplay.objectid);
                urlencoded.append("ios", isSafari ? true : false);
                urlencoded.append("seclevel", "SW");
                let drmPromise = store.dispatch("actGetDRMToken", urlencoded);
                let firePromise = this.updateDataOnFirebase({...this.liveplayerpayload});
                Promise.all([drmPromise, firePromise])
                .then(async ([drmRes, fireRes]) => {

                    // Both promises have resolved successfully
                    console.log("Firebase update result:", fireRes);

                    // Emit the event
                    eventBus.$emit("check-new-fire-data", true);
                    let contentData = this.currentChannelDisplay;
                    contentData['drmTokenResp'] = drmRes.data;
                    contentData['isStartOver'] = false;
                    contentData['isRestart'] = false;
                    window.uiManager.release();
                    // window.bmPlayer.off(bitmovin.player.PlayerEvent.SourceLoaded, this.onSourceLoadedHandler);
                    // window.bmPlayer.off(bitmovin.player.PlayerEvent.SourceLoaded, this.onPlayerReadyHandler);
                    this.liveplayerpayload = contentData;
                    console.log("contentData", contentData);
                    window.bmPlayer.unload();
                    this.setupPlayer(contentData)
                })
                .catch((err) => {
                    console.log("err", err);
                });

                if (
                    !window.activeChanelProgramsListAll[Num + 4] &&
                    window.activeChanelProgramsListAll.length != window.totalAllCategorycount
                ) {

                    window.currentPageIndex = window.currentPageIndex + 1;
                    if (this.getContentPlayingFromRails) {
                        this.contentListFromRail();
                    } else {
                        this.activeGenreContentList();
                    }
                }
            },
            async actPrevChannelChange() {
                this.nextPrevChannelHideShow = false;
                for (let index in window.activeChanelProgramsListAll) {
                    let Num = Number(index);
                    if (
                        window.activeChanelProgramsListAll[Num].objectid ==
                        this.currentChannelDisplay.objectid
                    ) {
                        this.nextChannelDisplay = window.activeChanelProgramsListAll[Num]
                            ? window.activeChanelProgramsListAll[Num]
                            : {};
                        this.prevChannelDisplay = window.activeChanelProgramsListAll[Num - 2]
                            ? window.activeChanelProgramsListAll[Num - 2]
                            : {};
                        this.currentChannelDisplay = window.activeChanelProgramsListAll[
                            Num - 1
                        ]
                            ? window.activeChanelProgramsListAll[Num - 1]
                            : {};

                        break;
                    }
                }
                const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                // this.content.watchedTime = await this.getContentProgress(this.content);
                console.log('PPP', this.currentChannelDisplay.streamUrl);
                let uriData = null;
                const urlencoded = new URLSearchParams();
                if(isSafari) {
                    uriData = await this.parseHlsManifest(this.currentChannelDisplay.streamUrl);
                    console.log(uriData, "uriData")
                    if(uriData) {
                        urlencoded.append("keyid", uriData[0]);
                        urlencoded.append("keyiv", uriData[1]);
                    }
                }
                urlencoded.append("contentid", this.currentChannelDisplay.objectid);
                urlencoded.append("ios", isSafari ? true : false);
                urlencoded.append("seclevel", "SW");
                let drmPromise = store.dispatch("actGetDRMToken", urlencoded);
                let firePromise = this.updateDataOnFirebase({...this.liveplayerpayload});
                Promise.all([drmPromise, firePromise])
                .then(async ([drmRes, fireRes]) => {

                    // Both promises have resolved successfully

                    // Emit the event
                    eventBus.$emit("check-new-fire-data", true);
                    let contentData = this.currentChannelDisplay;
                    contentData['drmTokenResp'] = drmRes.data;
                    contentData['isStartOver'] = false;
                    contentData['isRestart'] = false;
                    window.uiManager.release();
                    window.bmPlayer.off(bitmovin.player.PlayerEvent.SourceLoaded, this.onSourceLoadedHandler);
                    window.bmPlayer.off(bitmovin.player.PlayerEvent.Ready, this.onPlayerReadyHandler);
                    this.liveplayerpayload = contentData;
                    window.bmPlayer.unload();
                    this.setupPlayer(contentData)
                })
                .catch((err) => {
                    console.log("err", err);
                });
            },
            async activeGenreContentList() {
                console.log("activeGenreContentList", this.liveplayerpayload)
                let payload = {
                    'objecttype': 'CHANEL',
                    page: window.currentPageIndex
                }
                let arr = ["genre", "subgenre"];
                if (window.selectedGenre !== 'ALL CATEGORIES') {
                    payload.genre = window.selectedGenre;
                    payload.subgenre = window.selectedGenre;
                    payload.groupbyor = JSON.stringify(arr);
                }
                this.listContent(payload).then((item) => {
                    window.totalAllCategorycount = item.data.totalcount;
                    window.activeChanelProgramsListAll = [
                        ...(window.activeChanelProgramsListAll ?? []),
                        ...(item?.data?.data ?? [])
                    ];
                    this.getAlltheChanelPagination();
                });
            },
            async getAlltheChanelPagination(type = null) {
                let findCurrentChannel = false;
                console.log(this.liveplayerpayload, "getAlltheChanelPagination", window.activeChanelProgramsListAll);
                for (let index in window.activeChanelProgramsListAll) {
                    let Num = Number(index);
                    // console.log("Num", Num, window.activeChanelProgramsListAll?.[Num], this.liveplayerpayload?.objectid)
                    if (
                        (window.activeChanelProgramsListAll?.[Num]?.objectid == this.liveplayerpayload?.objectid) ||
                        (window.activeChanelProgramsListAll?.[Num]?.objectid == this.liveplayerpayload?.channelid)
                    ) {
                        // console.log("Num", findCurrentChannel)
                        this.currentChannelDisplay = window.activeChanelProgramsListAll[Num]
                            ? window.activeChanelProgramsListAll[Num]
                            : {};
                        this.nextChannelDisplay = window.activeChanelProgramsListAll[Num]
                            ? window.activeChanelProgramsListAll[Num + 1]
                            : {};
                        this.prevChannelDisplay = window.activeChanelProgramsListAll[Num]
                            ? window.activeChanelProgramsListAll[Num - 1]
                            : {};
                        findCurrentChannel = true;
                        break;
                    }
                }
                // console.log('prevChannelDisplay', this.prevChannelDisplay);
                console.log('nextChannelDisplay', this.nextChannelDisplay, window.activeChanelProgramsListAll.length < window.totalAllCategorycount);
                if (window.activeChanelProgramsListAll.length < window.totalAllCategorycount) {
                    window.currentPageIndex = window.currentPageIndex + 1;
                    this.activeGenreContentList();
                }
            },
            async actFromChannelList(program, index, nextPlay = false, showPlaylist = false) {
                console.log(program, 'currentChannelDisplay', index, nextPlay)
                program = { ...program, isStartOver: false, isRestart: false };
                if(index){
                    this.currentIndex = index;
                }
                let contentData = {...this.liveplayerpayload};
                contentData.position = window.bmPlayer.getCurrentTime() || 0;
                this.updateDataOnFirebase(contentData).then((data) => {
                    // console.log("<-- THECONTINUE WATCH UPDATE TO THE FIREBASE -->", data);
                    eventBus.$emit("check-new-fire-data", true);
                }).catch((err) => { alert('error') });
                this.liveplayerpayload = program;
                if(!nextPlay) {
                    this.showPlaylist = !this.showPlaylist;
                }
                let isPlaybackAllowed = await this.checkAvailabilityAllowsPlayback(program);
                if(this.liveplayerpayload.category == "TVCHANEL" && this.liveplayerpayload.objecttype !== "EPGPROGRAMME") {
                    this.currentChannelDisplay = program;
                }
                console.log(this.currentChannelDisplay, 'currentChannelDisplay', isPlaybackAllowed)
                if (isPlaybackAllowed) {
                    await window.uiManager.release();
                    // window.bmPlayer.off(bitmovin.player.PlayerEvent.SourceLoaded, this.onSourceLoadedHandler);
                    // window.bmPlayer.off(bitmovin.player.PlayerEvent.SourceLoaded, this.onPlayerReadyHandler);
                    await window.bmPlayer.unload();
                    await this.setupPlayer(program);
                } else {
                    // this.errorMessage = 'liveContentAccessError';
                    return;
                }
            },
            fetchRelatedContents() {
                let pageSize = 15;
                let payload = {
                    contentid: this.liveplayerpayload?.objectid,
                    params: {
                        displaylanguage: this.localDisplayLang == 'es' ? 'spa' : 'eng',
                        pagesize: pageSize,
                        page: 1,
                    },
                };
                if (this.liveplayerpayload?.contentprovider?.toLowerCase() !== "hotgo") {
                    payload.params.notincontentprovider = ["hotgo"];
                };
                store
                    .dispatch("relatedContents", payload)
                    .then((response) => {
                        if (response.data) {
                            // eventBus.$emit("relatedcontents-response", response.data);
                            // this.dataFetched = true;
                            if (response.data.errorcode) {
                                this.relatedList = [...this.relatedList];
                            } else {
                                this.relatedList = [...this.relatedList, ...response.data.data];
                            }
                            this.totalRelatedCount = response.data.totalcount;

                        }
                    }).catch((error) => { console.log("error==>", error) });
            },
            getSeasonList() {
                let payload = {
                    objecttype: "SEASON",
                    seriesid: this.liveplayerpayload.seriesid,
                    pagesize: '100',
                    page: '1',
                };
                store
                    .dispatch("listContent", payload)
                    .then((response) => {
                        // eventBus.$emit("season_listing_response", response.data);
                        if (response?.data?.reason) {
                            this.episodesList = [];
                            this.seasonsData = [];
                        } else {
                            // this.seasonCount = response?.data?.totalCount;
                            this.seasonsData = response?.data?.data;
                            this.episodesList = [];
                            let seasonNum = this.liveplayerpayload.seasonnum ? this.liveplayerpayload.seasonnum : 1;
                            this.fetchEpisodeList(this.liveplayerpayload.seriesid, seasonNum, 'fetchEpisodeList');
                        }
                    })
                    .catch((error) => console.log(error));
            },
            fetchEpisodeList(seriesId, seasonNum, type) {
                let pageSize = 15;
                let payload = {
                    objecttype: "CONTENT",
                    seriesid: seriesId,
                    seasonnum: seasonNum,
                    pagesize: pageSize,
                    page: this.episodePageNum,
                    displaylanguage: this.localDisplayLang,
                };
                // this.episodePaginatinInProgress = true;
                store
                    .dispatch("listContent", payload)
                    .then((response) => {
                        if (response.data.reason) {
                        } else {
                            // eventBus.$emit("send-episode-list", response.data);
                            // console.log("listContent_data", response.data.data);
                            this.episodesList = [...this.episodesList, ...response.data.data];
                            this.currentIndex = this.episodesList?.findIndex((item, i) => {
                                return item.objectid == this.liveplayerpayload.objectid;
                            });
                            if (response.data.totalcount == this.episodesList.length) {
                                // stop caling api
                            } else {
                                this.episodePageNum = this.episodePageNum + 1;
                                this.fetchEpisodeList(seriesId, seasonNum, type);
                            }

                        }
                    })
                    .catch((error) => console.log("episode-list-error", error));
            },
            async updateDataOnFirebase(content) {
                this.flushPlaybackAnalytics();
                if (!content || content.category === "TVCHANEL") return true;
                const position = finiteSeconds(content.position ?? window.bmPlayer?.getCurrentTime());
                const duration = finiteSeconds(content.duration || window.bmPlayer?.getDuration());
                if (!position) return true;
                const status = duration && position / duration >= 0.95 ? "COMPLETED" : "INPROGRESS";
                try {
                    await this.updateContinueWatch(content, status, position);
                } catch (error) {
                    console.warn("Continue watching update failed", error);
                }
                return true;
            },
            flushPlaybackAnalytics() {
                const content = this.analyticsSession?.finish();
                if (!content) return;
                content.position = finiteSeconds(window.bmPlayer?.getCurrentTime());
                content.duration = finiteSeconds(content.duration || window.bmPlayer?.getDuration());
                this.watchEvent(content);
            },
            watchEvent(content) {
                try {
                    this.watchedEvent(this.createAnalyticsObj(content));
                } catch (error) {
                    console.warn("Playback analytics failed", error);
                }
            },
            createAnalyticsObj(content) {
                let deviceInfo = localStorage.getItem('deviceInfo');
                try { deviceInfo = JSON.parse(deviceInfo || '{}') || {}; } catch (_) { deviceInfo = {}; }
                let platform = deviceInfo && deviceInfo.mobile ? 'mobweb' : 'web';
                const country = this.getCountry || {};
                let subtitle;
                let audio;
                if (this.purchaseList) {
                    this.contentpricemodel = "Paid";
                } else {
                    this.contentpricemodel = "Free"
                }
                let content_lang = "";
                if (content.contentlanguage && content.contentlanguage.length) {
                    this.getAllLanguageFullForm?.forEach(lang => {
                        if (lang["alpha3-b"] === content.contentlanguage[0].toLowerCase()) {
                            content_lang = lang.English;
                        }
                    })
                }
                const duration = finiteSeconds(content.duration);
                const playerPositionPerecentage = duration ? finiteSeconds(content.position) / duration * 100 : 0;
                const identity = playbackIdentity(content, this.currentChannelDisplay || {});

                let data = {
                    ...identity,
                    content_genre: content.defaultgenre || content.genre || "",
                    partner_id: content.partnerid || content.partner_id || "",
                    content_provider: identity.content_provider || content.contentprovider || content.content_provider || content.partnerid || "",
                    watch_time: finiteSeconds(content.watch_time),
                    view_count: content.view_count || 0,
                    content_duration: duration,
                    playback_type: "Streaming",
                    network_type: "WIFI",
                    source: this.$router?.currentRoute?.params?.section || localStorage.getItem("playback_source") || "",
                    country: country.CountryName,
                    day_of_week: this.getCurrentDayOfTheWeek(),
                    time_of_day: this.getCurrentTimeFrame(),
                    audio_language: audio,
                    subtitle_language: subtitle,
                    display_language: this.getCurrentDisplayLanguage(),
                    platform: platform || this.getPlatform(),
                    platform_type: deviceInfo.browser || this.checkBrowser(),
                    profile_id: this.profileid || this.subscriberid || identity.profile_id || "",
                };
                if(content_lang) {
                    data['content_language'] = content_lang;

                }
                if(content.category === "TVSHOW") {
                    data['episode_number'] = content.episodenum ? content.episodenum : "";
                    data['season_number'] = content.seasonnum ? content.seasonnum : "";
                    data['show_name'] = content.seriesname ? content.seriesname : "";
                }
                if(this.contentpricemodel) {
                    data['content_price'] = this.contentpricemodel;
                }
                if(content.category !== "TVCHANEL" && duration > 0) {
                    data['streamed_upto_25perc'] = playerPositionPerecentage >= 25 ? "TRUE" : "FALSE";
                    data['streamed_upto_50perc'] = playerPositionPerecentage >= 50 ? "TRUE" : "FALSE";
                    data['streamed_upto_75perc'] = playerPositionPerecentage >= 75 ? "TRUE" : "FALSE";
                    data['finished_watching'] = playerPositionPerecentage >= 90 ? "TRUE" : "FALSE";
                }
                return data;
            },
            async actGoLive(liveplayerpayload) {
                await this.updateDataOnFirebase({ ...this.liveplayerpayload });
                liveplayerpayload = { ...liveplayerpayload, isRestart: false, isStartOver: false, watchedduration: 0 };
                const channel = this.currentChannelDisplay;
                if (channel && channel.objectid === (liveplayerpayload.channelid || liveplayerpayload.objectid)) {
                    liveplayerpayload = { ...liveplayerpayload, ...channel, isRestart: false, isStartOver: false, watchedduration: 0 };
                }
                window.uiManager?.release();
                if (typeof bitmovin !== 'undefined' && bitmovin?.player) {
                    window.bmPlayer?.off(bitmovin.player.PlayerEvent.SourceLoaded, this.onSourceLoadedHandler);
                    window.bmPlayer?.off(bitmovin.player.PlayerEvent.Ready, this.onPlayerReadyHandler);
                }
                liveplayerpayload['program'] = null;
                liveplayerpayload['objecttype'] = "CHANEL";
                liveplayerpayload['contentprovider'] = null;
                const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                // this.content.watchedTime = await this.getContentProgress(this.content);
                let uriData = null;
                const urlencoded = new URLSearchParams();
                if(isSafari) {
                    uriData = await this.parseHlsManifest(liveplayerpayload.streamUrl);
                    if(uriData) {
                        urlencoded.append("keyid", uriData[0]);
                        urlencoded.append("keyiv", uriData[1]);
                    }
                }
                urlencoded.append("contentid", liveplayerpayload.channelid || liveplayerpayload.objectid);
                urlencoded.append("ios", isSafari ? true : false);
                urlencoded.append("seclevel", "SW");
                let drmPromise = store.dispatch("actGetDRMToken", urlencoded);
                let firePromise = Promise.resolve(true);
                return Promise.all([drmPromise, firePromise])
                .then(async ([drmRes, fireRes]) => {

                    // Both promises have resolved successfully
                    console.log("Firebase update result:", fireRes);

                    // Emit the event
                    eventBus.$emit("check-new-fire-data", true);
                    let contentData = {...liveplayerpayload};
                    contentData['drmTokenResp'] = drmRes.data;
                    contentData['isStartOver'] = false;
                    contentData['isRestart'] = false;
                    window.uiManager.release();
                    this.liveplayerpayload = contentData;
                    console.log("contentData", contentData);
                    window.bmPlayer.unload();
                    this.setupPlayer(contentData)
                })
                .catch((err) => {
                    console.log("err", err);
                });
            },
            async EpgApiCall(contentInformation, page=1) {
                let channelid = contentInformation.idepgchannel || contentInformation.channelid;
                const today = moment().tz(moment.tz.guess()); // guess local timezone
                const localDate = today.format("YYYY-MM-DD");
                let getTimeInUTC = this.getStartAndEndTimesInUTC(localDate);
                const payload = {
                    start: getTimeInUTC.startUTC,
                    stop: getTimeInUTC.endUTC,
                    localDisplayLang: this.localDisplayLang,
                    page,
                    pagesize: 10,
                    orderby: { "channelno": 'ASC' },
                };
                if (channelid) {
                    payload.idepgchannel = "[" + channelid + "]"
                }
                try {
                    const res = await this.mapEpgXmlData(payload);
                    const parsedData = res.data ? xmlToJson.parse(res.data) : {};
                    if (parsedData?.tv) {
                        // console.log(parsedData?.tv, 'parsedData_tv')
                        this.totalCount = parsedData?.tv?.totalcount || 0;
                        let channelsData = [];
                        if (!Array.isArray(parsedData?.tv?.channel) || parsedData?.tv?.totalcount == 1) {
                            channelsData = [parsedData?.tv?.channel];
                        } else {
                            channelsData = parsedData?.tv?.channel;
                        }

                        const programsData = parsedData?.tv?.programme || [];

                        // this.channelsData = [...(this.channelsData || []), ...channelsData];
                        this.programsData = [...(this.programsData || []), ...programsData];
                        // console.log("programsData", this.programsData);
                        this.FetchCurrentProgram(contentInformation, this.programsData);
                    }
                } catch (err) {
                    console.error("Error fetching EPG XML data:", err);
                    this.finalData = [];
                }
            },
            FetchCurrentProgram(contentInformation, data) {
                // console.log(data, "currentProgram_0");
                const currentProgram = data.filter((item, i) => {return this.isCurrentProgram(item)});
                // console.log(currentProgram, "currentProgram");
                contentInformation['program'] = currentProgram?.[0];
            },
            isCurrentProgram(item) {
                const currentTime = moment().utc().local().valueOf();
                let startTime = moment.utc(moment(item.start, "YYYYMMDDHHmmss Z")).local().valueOf();
                let endTime = moment.utc(moment(item.stop, "YYYYMMDDHHmmss Z")).local().valueOf();
                return (startTime <= currentTime) && (currentTime <= endTime);
            },
            isFutureProgram(item) {
                let currentTime = moment().utc().local().valueOf();
                let startTime = moment.utc(moment(item.start, "YYYYMMDDHHmmss Z")).local().valueOf();
                return startTime > currentTime;
            },
            onSourceLoadedHandler(contentInformation) {
                console.log('reaching_SourceLoaded');
                this.authorizeStreamApiCall(contentInformation);
                if(contentInformation.category == "TVCHANEL") {
                    this.EpgApiCall(contentInformation, 1);
                }
            },
            onPlayerReadyHandler(contentInformation) {
                console.log('reaching_onPlayerReady', contentInformation.watchedduration);
                if (contentInformation.watchedduration && contentInformation.watchedduration > 0) {
                    let savedWatchTime =  parseFloat(contentInformation.watchedduration);
                    console.log('savedWatchTime_onPlayerReady', savedWatchTime)
                    window.bmPlayer.seek(savedWatchTime);
                }
            },
            getSessionUUID() {
                if (window.crypto?.randomUUID) {
                    return window.crypto.randomUUID();
                }

                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
                    const r = Math.random() * 16 | 0;
                    const v = c === 'x' ? r : (r & 0x3 | 0x8);
                    return v.toString(16);
                });
            },
            authorizeStreamApiCall(contentInformation) {
                const payload = {
                    contentId: contentInformation?.channelid || contentInformation?.objectid,
                    params: {
                        devicetype: "PC",
                    },
                };
                 console.log(this.appConfig.featureEnabled.isConcurrencyEnabled, 'isConcurrencyEnabled')
                if (this.appConfig.featureEnabled.isConcurrencyEnabled) {
                   
                    this.authorizeCurrentStreamApi().then(
                        (setStreamResponse) => {
                            console.log("authorizeCurrentStreamApi", setStreamResponse)
                        if (setStreamResponse.data.errorcode) {
                            this.actClosePlayer();

                            eventBus.$emit("showAuthorizeErrorMessage", {
                            state: true,
                            messageData: {
                                title: this.$t("Error"),
                                message: this.$t("Platback Device Limit Reached"),
                            },
                            });
                        }
                        }
                    ).catch((err)=>{});
                }
            },
            setStreamApiCall(contentInformation) {
                const payload = {
                    contentId: contentInformation?.channelid || contentInformation?.objectid,
                    params: {
                        devicetype: "PC",
                    },
                };
                 console.log(this.appConfig.featureEnabled.isConcurrencyEnabled, '--', payload, 'isConcurrencyEnabled')
                if (this.appConfig.featureEnabled.isConcurrencyEnabled) {
                   
                    this.setCurrentStreamApi(payload).then(
                        (setStreamResponse) => {
                        console.log("THE SETSTREAM PLAYER API IS CALLED --> ", setStreamResponse)
                        if (setStreamResponse.data.errorcode) {
                            this.actClosePlayer();

                            eventBus.$emit("showAuthorizeErrorMessage", {
                            state: true,
                            messageData: {
                                title: this.$t("Error"),
                                message: this.$t("Platback Device Limit Reached"),
                            },
                            });
                        }
                        }
                    ).catch((err)=>{});
                }
            },
            unsetStreamApiCall(contentInformation) {
                 const unSetPayload = {
                    contentId: contentInformation?.channelid || contentInformation?.objectid
                };
                if (this.appConfig?.featureEnabled?.isConcurrencyEnabled) {
                this.unsetCurrentStreamApi(unSetPayload).then((unSetStreamResp) => {
                    console.log("THE UNSETSTREAM PLAYER API IS CALLED --> ", unSetStreamResp);
                });
                }
            },
            startCountdown() {
                let total = 10;
                this.countdown = total;
                this.nextBtnprogress = 0;
                clearInterval(this.countdownTimer);
                this.countdownTimer = setInterval(() => {
                    this.countdown--;
                    this.nextBtnprogress = ((total - this.countdown) / total) * 100;
                    if (this.countdown <= 0) {
                        this.playNextNow();
                    }
                }, 1000);
            },
            playNextNow() {
                clearInterval(this.countdownTimer);
                this.showNextPopup = false;
                const next = this.nextItem;
                this.nextItem = null;
                if (!next) { return; }
                this.$nextTick(async () => {
                     const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                    // this.content.watchedTime = await this.getContentProgress(this.content);
                    let uriData = null;
                    const urlencoded = new URLSearchParams();
                    if(isSafari) {
                        uriData = await this.parseHlsManifest(next.streamUrl);
                        if(uriData) {
                            urlencoded.append("keyid", uriData[0]);
                            urlencoded.append("keyiv", uriData[1]);
                        }
                    }
                    urlencoded.append("contentid", next.objectid);
                    urlencoded.append("ios", isSafari ? true : false);
                    urlencoded.append("seclevel", "SW");
                    let drmPromise = store.dispatch("actGetDRMToken", urlencoded);
                    Promise.all([drmPromise])
                    .then(async ([drmRes]) => {

                        // Emit the event
                        eventBus.$emit("check-new-fire-data", true);
                        let contentData = next;
                        contentData['drmTokenResp'] = drmRes.data;
                        contentData['isStartOver'] = false;
                    contentData['isRestart'] = false;
                        window.uiManager.release();
                        console.log("contentData", contentData);
                        window.bmPlayer.unload();
                        // this.setupPlayer(contentData);
                        this.actFromChannelList(contentData, this.currentIndex, true);
                        this.currentIndex++;
                    })
                    .catch((err) => {
                        console.log("err", err);
                    });
                });
            },
            cancelNext() {
                clearInterval(this.countdownTimer);
                this.showNextPopup = false;
                this.nextItem = null;           // clear selection
                this.actClosePlayer();
            },
            onTimeChanged() {
                if (this.showNextPopup || !window.bmPlayer) {
                    return;
                }
                const duration = window.bmPlayer.getDuration();
                const currentTime = window.bmPlayer.getCurrentTime();
                if (duration > 0) {
                    const remaining = duration - currentTime;
                    if (remaining <= 10) {
                        const list = this.getNextItemList();
                        const nextIdx = this.currentIndex + 1;
                        if (list && nextIdx < list.length) {
                            this.nextItem = list[nextIdx];
                            this.showNextPopup = true;
                            this.startCountdown();
                        }
                    }
                }
            },
            getNextItemList() {
                if (!this.liveplayerpayload) { return []; }
                if (this.liveplayerpayload.category === "TVSHOW") {
                    if (this.episodesList && this.episodesList.length) {
                        return this.episodesList;
                    }
                    if (this.relatedList && this.relatedList.length) {
                        return this.relatedList;
                    }
                } else if (this.liveplayerpayload.category === "MOVIE") {
                    if (this.relatedList && this.relatedList.length) {
                        return this.relatedList;
                    }
                }
                return [];
            },
            getQualityLabels(data)  {
                if (!data.width) {
                    return;
                }
                if (data.width >= 1920) {
                    // console.log('qualitydata', data.width + ' (Full HD)')
                    return data.width + 'p (Full HD)';
                }
                else if (data.width >= 1200) {
                    // console.log('qualitydata', data.width + ' (HD)')
                    return data.width + 'p (HD)';
                }
                else {
                    // console.log('qualitydata', data.width)
                    return data.width + 'p';
                }
            },
            // getSubtitleLabels(data)  {
            //     if (!data.label) {
            //         return;
            //     }
            //     var label = data.label.toUpperCase() + ' (SubtitleID: ' + data.id + ')';
            //     if (data.label === 'en') {
            //         return label += ' (original)';
            //     }
            //     return label;
            // },
            // getTrackLabels(data)  {
            //     if (!data.mimeType) {
            //         return;
            //     }
            //     if (data.mimeType.indexOf('audio') >= 0) {
            //         return data.lang.toUpperCase();
            //     }
            //     return data.lang;
            // },
            spliceText(text, maxLength) {
                if (text.length > maxLength) {
                    return text.slice(0, maxLength) + '...'; // Splice text and add ellipsis
                } else {
                    return text; // If text is within the limit, return it as is
                }
            },
            startTimer() {
                console.log('===>intervalId', this.intervalId)
                if (this.intervalId) return;
                // startTime = Date.now();
                console.log("startTimer")
                this.intervalId = setInterval(() => {
                    this.setStreamApiCall(this.liveplayerpayload);
                }, this.remainingTime);
            },
            pauseTimer() {
                if (!this.intervalId) return;
                console.log("pauseTimer")
                clearInterval(this.intervalId);
                this.intervalId = null;

                // const elapsed = Date.now() - startTime;
                // remainingTime -= elapsed;
            },
            updateNextContentPopup() {
                const btn = document.querySelector(
                    '.bmpui-ui-next-content-button'
                );
                console.log("updateNextContentPopup", this.nextItem, this.showNextPopup, (!this.showNextPopup || !this.nextItem), btn)
                if (!btn) return;

                if (!this.showNextPopup ||
                    !this.nextItem) {

                    btn.style.display = 'none';
                    return;
                }

                btn.style.display = 'flex';

                btn.innerHTML = `
                    <div class="next-item-block">
                        <div class="next-item-img">
                        <img
                            src="${this.getLowPoster(this.nextItem)}"
                            class="card-img"
                        />
                        </div>

                        <div class="next-item-details">
                        <span
                            class="next-item-countdown"
                        >
                            Next episode starts in
                            (${this.countdown}s)
                        </span>

                        <span
                            class="next-item-title"
                        >
                            ${this.nextItem.title || ''}
                        </span>

                        <span
                            class="next-item-description"
                        >
                            ${this.spliceText(
                                        this.nextItem.shortdescription,
                                        50
                                    )}
                        </span>
                        </div>

                        <div
                        class="progress-bg"
                        style="
                        width:
                        ${this.nextBtnprogress}%">
                        </div>
                    </div>
                    `;
            }

        },
        beforeDestroy() {
            window.removeEventListener("pagehide", this.flushPlaybackAnalytics);
            this.flushPlaybackAnalytics();
            this.pauseTimer();
            window.totalAllCategorycount = 0;
            window.activeChanelProgramsListAll = [];
            document.body.style.overflow = "auto"
            this.destroyPlayer();
        },
        mixins: [PlaybackUtilities, Utility, FirebaseActions, googleAnalytics, Redirection, MMAnalytics]
    }
</script>
<style lang="scss" scoped>
    @import "@/sass/_components.scss";  
    .player-wrapper {
        // aspect-ratio: 16/9 auto;
        box-shadow: 0 0 30px rgba(0, 0, 0, 0.7);
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        overflow: hidden;
        z-index: 9999999;
        width: 100%;
        height: 100%;
    }

    .nextPrevChannel {
        position: absolute;
        display: flex;
        justify-content: space-between;
        z-index: 9999;
        width: 100%;
        top: 50%;
        transform: translate(0%, -79%);
        padding: 0rem 1rem;
        color: white;
        font-size: 0.8rem;
        z-index: 2;
        pointer-events: none;
        div {
            display: flex;
            align-items: center;
            cursor: pointer;
            gap: 0.5rem;
            pointer-events: all;

            span {
                padding: 0.4rem;
                max-width: 10rem;
                min-width: 9rem;
            }
        }

        .farword_backword_controls {
            gap: 0.8rem;
        }
    }

    .PlayListView {
        position: absolute;
        top: 5%;
        z-index: 999;
    }
    .error-message {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #212121;
        opacity: 0.8;
        z-index: 999999999;
        display: flex;
        align-items: center;
        justify-content: center;
        .error-message-content {
        padding: 5rem;
        border: 1px solid #222222;
        background: #000000;
        max-width: 600px;
        .error-message-header {
            text-align: center;
        }
        hr {
            width: 90%;
            margin: auto;
        }
        .error-message-body {
            padding: 2rem 1rem;
            text-align: center;
        }
        .error-message-footer {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 1rem;
            .error-message-btns {
            border-radius: 8px;
            background-color: #999;
            padding: 1rem 2rem;
            font-weight: bold;
            font-size: clamp(0.5rem, 2vw, 1rem);
            text-align: center;
            cursor: pointer;
            &:hover {
                transform: scale(1.05);
            }
            }
            .btn_one {
            background: $primary-btn-color;
            }
            .btn_two {
            background: #ffffff;
            color: #000
            }
        }
        }
    }
    .next-btn-popup {
        position: fixed;
        /* top: 0; */
        /* left: 0; */
        right: 2%;
        bottom: 10%;
        background-color: #212121;
        opacity: 0.8;
        z-index: 999999999;
        display: flex;
        align-items: center;
        justify-content: center;
        width: fit-content;
        height: fit-content;
        max-width: 420px;
        .next-btn {
            position: relative;
            border: 0.2rem #000000;
            padding: 0.5rem ;
            background: rgba(0,0,0,0.7);
            color: white;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid #000000;
            font-size: 1.2rem;
            // flex-direction: column;
            gap: 0.5rem;
            .next-item-img {
                position: relative;
                .card-img {
                    width: 156px;
                    aspect-ratio: 16/9;
                }
                .card-play {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    translate: -50% -50%;
                    width: 20%;
                }
            }
            .next-item-details {
                display: flex;
                flex-direction: column;
                gap: 0.3rem;
                align-items: flex-start;
                .next-item-countdown {
                    color: #f74803;
                    font-size: large;
                }
                .next-item-title {
                    font-size: medium;
                    text-align: start;
                }
                .next-item-description {
                    font-size: small;
                    text-align: start;
                }
            }
            .progress-bg {
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                background: #f4f4f2a6; /* progress color */
                z-index: -1;
                transition: width 1s linear;
            }
        }
    }
    .currentChannelDisplay-popup {
        position: fixed;
        left: 2%;
        bottom: 10%;
        background-color: #212121;
        opacity: 0.8;
        z-index: 999999999;
        display: flex;
        align-items: center;
        justify-content: center;
        width: fit-content;
        height: fit-content;
        max-width: 420px;
        .next-btn {
            position: relative;
            border: 0.2rem #000000;
            padding: 0.5rem ;
            background: rgba(0,0,0,0.7);
            color: white;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid #000000;
            font-size: 1.2rem;
            // flex-direction: column;
            gap: 0.5rem;
            .next-item-img {
                position: relative;
                .card-img {
                    width: 128px;
                    aspect-ratio: 16/9;
                }
                .card-play {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    translate: -50% -50%;
                    width: 20%;
                }
            }
            .next-item-details {
                display: flex;
                flex-direction: column;
                gap: 0.3rem;
                align-items: flex-start;
                .next-item-countdown {
                    color: #f74803;
                    font-size: large;
                }
                .next-item-title {
                    font-size: medium;
                    text-align: start;
                }
                .next-item-description {
                    font-size: small;
                    text-align: start;
                }
            }
            .progress-bg {
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                background: #f4f4f2a6; /* progress color */
                z-index: -1;
                transition: width 1s linear;
            }
        }
    }
</style>